module.exports = __webpack_public_path__ + "img/luckyDraw.de049cb5.png";